var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.styleType === "normal"
    ? _c(
        "div",
        [
          _vm._l(_vm.inputData.checkbox, function(option, index) {
            return _c("div", { key: index }, [
              _c("label", [
                _c("input", {
                  attrs: { type: "checkbox", name: _vm.inputData.label },
                  domProps: {
                    value: option.value,
                    checked: _vm.value.indexOf(option.value) >= 0
                  },
                  on: {
                    click: function($event) {
                      return _vm.updateValue(option.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _vm._v(_vm._s(option.value))
                ])
              ])
            ])
          }),
          _vm._v(" "),
          _vm.status === true
            ? _c("div", { staticClass: "validation-text" }, [
                _vm._v("\n    " + _vm._s(_vm.t.pleaseSelectOption) + "\n  ")
              ])
            : _vm._e()
        ],
        2
      )
    : _vm.styleType === "material"
    ? _c(
        "div",
        _vm._l(_vm.inputData.checkbox, function(option, index) {
          return _c("div", { key: index }, [
            _c("label", { staticClass: "rp-material-checkbox" }, [
              _c("input", {
                attrs: { type: "checkbox", name: _vm.inputData.label },
                domProps: {
                  value: option.value,
                  checked: _vm.value.indexOf(option.value) >= 0
                },
                on: {
                  click: function($event) {
                    return _vm.updateValue(option.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(option.value))
              ])
            ])
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1564448", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1564448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/form/CheckboxInput.vue
// module id = null
// module chunks = 